import { MobizSettingsValue } from '../../common-react/settings';

import { Party } from './party.do';

export class UserRecipients extends MobizSettingsValue {
  recipients: Party[] = [];

  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    switch (propertyName) {
      case 'recipients':
        if (!propertyValue || !Array.isArray(propertyValue)) {
          return [];
        }
        try {
          // tslint:disable-next-line:no-any
          return propertyValue.map((item: any): Party => {
            return new Party(item);
          });
        } catch (err) {
          // Ignore errors and return an empty list.
          return [];
        }

      default:
        return super.coercePropertyType(propertyName, propertyValue);
    }
  }

}
